module.exports = __webpack_public_path__ + "static/media/sf-test-10.5bb2e53b.mp3";